import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { notifyManager } from './notifyManager.mjs';
import { Mutation } from './mutation.mjs';
import { matchMutation, noop } from './utils.mjs';
import { Subscribable } from './subscribable.mjs'; // CLASS

var MutationCache = /*#__PURE__*/function (_Subscribable) {
  _inherits(MutationCache, _Subscribable);

  var _super = _createSuper(MutationCache);

  function MutationCache(config) {
    var _this;

    _classCallCheck(this, MutationCache);

    _this = _super.call(this);
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  _createClass(MutationCache, [{
    key: "build",
    value: function build(client, options, state) {
      var mutation = new Mutation({
        mutationCache: this,
        logger: client.getLogger(),
        mutationId: ++this.mutationId,
        options: client.defaultMutationOptions(options),
        state: state,
        defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
      });
      this.add(mutation);
      return mutation;
    }
  }, {
    key: "add",
    value: function add(mutation) {
      this.mutations.push(mutation);
      this.notify({
        type: 'added',
        mutation: mutation
      });
    }
  }, {
    key: "remove",
    value: function remove(mutation) {
      this.mutations = this.mutations.filter(function (x) {
        return x !== mutation;
      });
      this.notify({
        type: 'removed',
        mutation: mutation
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      notifyManager.batch(function () {
        _this2.mutations.forEach(function (mutation) {
          _this2.remove(mutation);
        });
      });
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.mutations;
    }
  }, {
    key: "find",
    value: function find(filters) {
      if (typeof filters.exact === 'undefined') {
        filters.exact = true;
      }

      return this.mutations.find(function (mutation) {
        return matchMutation(filters, mutation);
      });
    }
  }, {
    key: "findAll",
    value: function findAll(filters) {
      return this.mutations.filter(function (mutation) {
        return matchMutation(filters, mutation);
      });
    }
  }, {
    key: "notify",
    value: function notify(event) {
      var _this3 = this;

      notifyManager.batch(function () {
        _this3.listeners.forEach(function (_ref) {
          var listener = _ref.listener;
          listener(event);
        });
      });
    }
  }, {
    key: "resumePausedMutations",
    value: function resumePausedMutations() {
      var _this4 = this;

      var _this$resuming;

      this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(function () {
        var pausedMutations = _this4.mutations.filter(function (x) {
          return x.state.isPaused;
        });

        return notifyManager.batch(function () {
          return pausedMutations.reduce(function (promise, mutation) {
            return promise.then(function () {
              return mutation.continue().catch(noop);
            });
          }, Promise.resolve());
        });
      }).then(function () {
        _this4.resuming = undefined;
      });
      return this.resuming;
    }
  }]);

  return MutationCache;
}(Subscribable);

export { MutationCache };